<div class="modal-header">
    <h5 class="modal-title">{{vendorInfo.vendorId ? 'Edit' : 'Add'}} Vendor</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[vendorForm]"></dirty-tracking>
<form novalidate #vendorForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <div class="row gx-3">
            <div class="col-md-8 mb-3">
                <label for="vendorName" class="form-label">Vendor Name<sup class="text-danger">*</sup></label>
                <input type="text" focus-me class="form-control form-control-lg" id="vendorName" name="vendorName" placeholder="Vendor Name" required [(ngModel)]="vendorInfo.vendorName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorStatus" class="form-label">Status</label>
                <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                    <label class="m-0">
                        <input type="checkbox" id="vendorStatus" name="vendorStatus" [(ngModel)]="vendorInfo.isActive"><span class="user-toggle" [ngClass]="vendorInfo.isActive ? 'text-success' : 'text-danger'">{{vendorInfo.isActive ?
                            'Active' : 'Deactivated'}}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-8 mb-3">
                <label for="vendorAddress1" class="form-label">Street Address</label>
                <input type="text" class="form-control form-control-lg" id="vendorAddress1" placeholder="Address 1" name="vendorAddress1" [(ngModel)]="vendorInfo.addressLine1">
            </div>
            <div class="col-md mb-3">
                <label for="vendorAddress2" class="form-label">Apt, Suite, Etc.</label>
                <input type="text" class="form-control form-control-lg" id="vendorAddress2" placeholder="Address 2" name="vendorAddress2" [(ngModel)]="vendorInfo.addressLine2">
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="vendorCity" class="form-label">City</label>
                <input type="text" class="form-control form-control-lg" id="vendorCity" placeholder="City" name="vendorCity" [(ngModel)]="vendorInfo.city">
            </div>
            <div class="col-md mb-3">
                <label for="vendorState" class="form-label">State</label>
                <select id="vendorState" class="form-select form-select-lg" name="vendorState" [(ngModel)]="vendorInfo.state">
                    <option [value]="null">Select State</option>
                    <option *ngFor="let s of stateList" [value]="s.value">{{s.text}}</option>
                </select>
            </div>
            <div class="col-md mb-3">
                <label for="vendorZip" class="form-label">Zip</label>
                <input type="text" class="form-control form-control-lg" id="vendorZip" placeholder="Zip" name="vendorPostalCode" [(ngModel)]="vendorInfo.postalCode">
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="vendorPhone" class="form-label">Phone</label>
                <input type="text" class="form-control form-control-lg" id="vendorPhone" placeholder="Phone" name="vendorPhoneNumber" [(ngModel)]="vendorInfo.phoneNumber">
            </div>
            <div class="col-md mb-3">
                <label for="vendorFax" class="form-label">Fax</label>
                <input type="text" class="form-control form-control-lg" id="vendorFax" placeholder="Fax" name="vendorFaxNumber" [(ngModel)]="vendorInfo.faxNumber">
            </div>
            <div class="col-md mb-3">
                <label for="vendorTerms" class="form-label">Terms URL</label>
                <input type="text" class="form-control form-control-lg" id="vendorTerms" placeholder="Terms URL" name="vendorTermsURL" [(ngModel)]="vendorInfo.termsURL">
            </div>
        </div>
        <hr />
        <h5 class="text-primary text-strong mb-3">PO Transmission</h5>
        <div class="accordion" id="transmissonAccordion">
            <div class="row gx-3">
                <div class="col-md-auto mb-3">
                    <label for="vendorTransmissionFileType" class="form-label d-block">Transmission File Type</label>
                    <div class="btn-group btn-group-lg" role="group">
                        <button type="button" class="btn btn-outline-black" *ngFor="let type of PDxPOFileTypes" (click)="setPOFileType(type.value)" [ngClass]="{'active': type.value == vendorInfo.poFileType}">{{type.text}}</button>
                    </div>
                </div>
                <div class="col-md-auto mb-3">
                    <label for="vendorTransmissionMethod" class="form-label d-block">Transmission Method</label>
                    <div class="btn-group btn-group-lg" role="group">
                        <button type="button" class="btn btn-outline-black" *ngFor="let type of PDxTransmissionMethods" (click)="setTransmissionMethod(type.value)" [ngClass]="{'active': type.value == vendorInfo.poTransmissionMethod}">{{type.text}}</button>
                    </div>
                </div>
            </div>
            <ng-container [ngSwitch]="vendorInfo.poFileType">
                <div class="" id="fileTypeEDI" *ngSwitchCase="PDxPOFileType.EDI">
                    <div class="row gx-3">
                        <div class="col-md mb-3">
                            <label for="ediFilePrefix" class="form-label">File Prefix</label>
                            <input type="text" class="form-control form-control-lg" id="ediFilePrefix" placeholder="File Prefix" name="ediFilePrefix" [(ngModel)]="vendorInfo.ediFilePrefix">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediFileExtension" class="form-label">File Extension</label>
                            <input type="text" class="form-control form-control-lg" id="ediFileExtension" placeholder="File Extension" name="ediFileExtension" [(ngModel)]="vendorInfo.ediFileExtension">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>
                    <div class="row gx-3">
                        <div class="col-md mb-3">
                            <label for="ediUseBillingNumber" class="form-label">Use Billing Number</label>
                            <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                                <label class="m-0">
                                    <input type="checkbox" id="ediUseBillingNumber" name="ediUseBillingNumber" [(ngModel)]="vendorInfo.ediUseBillingNumber"><span class="user-toggle">{{vendorInfo.ediUseBillingNumber ?
                                        'Yes' : 'No'}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediIncludeMFInformation" class="form-label">Include MF Information</label>
                            <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                                <label class="m-0">
                                    <input type="checkbox" id="ediIncludeMFInformation" name="ediIncludeMFInformation" [(ngModel)]="vendorInfo.ediIncludeMFInformation"><span class="user-toggle">{{vendorInfo.ediIncludeMFInformation ? 'Yes' : 'No'}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediIncludePriceUOM" class="form-label">Include Price UOM</label>
                            <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                                <label class="m-0">
                                    <input type="checkbox" id="ediIncludePriceUOM" name="ediIncludePriceUOM" [(ngModel)]="vendorInfo.ediIncludePriceUOM"><span class="user-toggle">{{vendorInfo.ediIncludePriceUOM ? 'Yes' : 'No'}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediIncludeNDCInformation" class="form-label">Include NDC Information</label>
                            <div class="form-check checkbox-slider--b-flat checkbox-slider-md">
                                <label class="m-0">
                                    <input type="checkbox" id="ediIncludeNDCInformation" name="ediIncludeNDCInformation" [(ngModel)]="vendorInfo.ediIncludeNDCInformation"><span class="user-toggle">{{vendorInfo.ediIncludeNDCInformation ? 'Yes' : 'No'}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-3">
                        <div class="col-md mb-3">
                            <label for="ediReceiverID" class="form-label">Receiver ID</label>
                            <input type="text" class="form-control form-control-lg" id="ediReceiverID" placeholder="Receiver ID" name="ediReceiverID" [(ngModel)]="vendorInfo.ediReceiverID">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediReceiverIDQualifier" class="form-label">Receiver ID Qualifier</label>
                            <input type="text" class="form-control form-control-lg" id="ediReceiverIDQualifier" placeholder="Receiver ID Qualifier" name="ediReceiverIDQualifier" [(ngModel)]="vendorInfo.ediReceiverIDQualifier">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediSenderID" class="form-label">Sender ID</label>
                            <input type="text" class="form-control form-control-lg" id="ediSenderID" placeholder="Sender ID" name="ediSenderID" [(ngModel)]="vendorInfo.ediSenderID">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-3">
                            <label for="ediAddressCodeQualifier" class="form-label">Address Code Qualifier</label>
                            <input type="text" class="form-control form-control-lg" id="ediAddressCodeQualifier" placeholder="Address Code Qualifier" name="ediAddressCodeQualifier" [(ngModel)]="vendorInfo.ediAddressCodeQualifier">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>

                </div>
            </ng-container>
            <ng-container [ngSwitch]="vendorInfo.poTransmissionMethod">
                <!-- email transmission -->
                <div class="" id="transmissionEmail" *ngSwitchCase="PDxTransmissionMethod.Email">
                    <div class="row gx-3">
                        <div class="col-md mb-3">
                            <label for="vendorEmailTransmission" class="form-label">Transmission Email Address</label>
                            <input type="text" class="form-control form-control-lg" id="vendorEmailTransmission" placeholder="Transmission Email Address" name="vendorEmailTransmission" [(ngModel)]="vendorInfo.poEmailAddress">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>
                </div>
                <!-- fax transmission -->
                <div class="" id="transmissionFax" *ngSwitchCase="PDxTransmissionMethod.EFax">
                    <div class="row gx-3">
                        <div class="col-md mb-3">
                            <label for="vendorFaxTransmission" class="form-label">Transmission eFax Address</label>
                            <input type="text" class="form-control form-control-lg" id="vendorFaxTransmission" placeholder="Transmission eFax Address" name="vendorFaxTransmission" [(ngModel)]="vendorInfo.poEFaxAddress">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>
                </div>
                <!-- sftp transmission -->
                <div class="" id="transmissionSFTP" *ngSwitchCase="PDxTransmissionMethod.SFTP">
                    <div class="row gx-3">
                        <div class="col-md mb-4">
                            <label for="vendorSftpServer" class="form-label">SFTP Server</label>
                            <input type="text" class="form-control form-control-lg" id="vendorSftpServer" placeholder="Server Address" name="vendorSftpServer" [(ngModel)]="vendorInfo.poSFTPServer">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-4">
                            <label for="vendorSftpSubdirectory" class="form-label">Outbound Subdirectory (optional)</label>
                            <input type="text" class="form-control form-control-lg" id="vendorSftpSubdirectory" placeholder="Subdirectory" name="vendorSftpSubdirectory" [(ngModel)]="vendorInfo.poSFTPDirectory">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-4">
                            <label for="vendorSftpInboundSubdirectory" class="form-label">Inbound Subdirectory (optional)</label>
                            <input type="text" class="form-control form-control-lg" id="vendorSftpInboundSubdirectory" placeholder="Subdirectory" name="vendorSftpInboundSubdirectory" [(ngModel)]="vendorInfo.poSFTPInboundDirectory">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>
                    <div class="row gx-3">
                        <div class="col-md mb-4">
                            <label for="vendorSftpUsername" class="form-label">Username</label>
                            <input type="text" class="form-control form-control-lg" id="vendorSftpUsername" placeholder="Username" name="vendorSftpUsername" [(ngModel)]="vendorInfo.poSFTPUsername">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                        <div class="col-md mb-4">
                            <label for="vendorSftpPassword" class="form-label">Password</label>
                            <input type="text" class="form-control form-control-lg" id="vendorSftpPassword" placeholder="Password" name="vendorSftpPassword" [(ngModel)]="vendorInfo.poSFTPPassword">
                            <div class="invalid-feedback">
                                <i class="fas fa-exclamation-circle"></i> This field is required.
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <hr />
        <h5 class="text-primary text-strong mb-3">Stocking Status Updates</h5>
        <div class="row gx-3">
            <div class="col-md-6 mb-4">
                <label for="stockingSFTPServer" class="form-label">SFTP Server</label>
                <input type="text" class="form-control form-control-lg" id="stockingSFTPServer" placeholder="Server Address" name="stockingSFTPServer" [(ngModel)]="vendorInfo.stockingSFTPServer">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-4" *ngIf="vendorInfo.stockingSFTPServer">
                <label for="stockingSFTPDirectory" class="form-label">Subdirectory</label>
                <input type="text" class="form-control form-control-lg" id="stockingSFTPDirectory" placeholder="Subdirectory" name="stockingSFTPDirectory" [(ngModel)]="vendorInfo.stockingSFTPDirectory">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="vendorInfo.stockingSFTPServer">
            <div class="col-md mb-4">
                <label for="stockingSFTPUsername" class="form-label">Username</label>
                <input type="text" class="form-control form-control-lg" id="stockingSFTPUsername" placeholder="Username" name="stockingSFTPUsername" [(ngModel)]="vendorInfo.stockingSFTPUsername">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-4">
                <label for="stockingSFTPPassword" class="form-label">Password</label>
                <input type="text" class="form-control form-control-lg" id="stockingSFTPPassword" placeholder="Password" name="stockingSFTPPassword" [(ngModel)]="vendorInfo.stockingSFTPPassword">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <hr />
        <h5 class="text-primary text-strong mb-3">Primary Contact</h5>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="vendorContactFirstName" class="form-label">First Name</label>
                <input type="text" class="form-control form-control-lg" id="vendorContactFirstName" placeholder="First Name" name="vendorContactFirstName" [(ngModel)]="vendorInfo.primaryContactFirstName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorContactLastName" class="form-label">Last Name</label>
                <input type="text" class="form-control form-control-lg" id="vendorContactLastName" placeholder="Last Name" name="vendorContactLastName" [(ngModel)]="vendorInfo.primaryContactLastName">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="vendorContactEmail" class="form-label">Email Address</label>
                <input type="email" class="form-control form-control-lg" id="vendorContactEmail" placeholder="Email Address" name="vendorContactEmail" [(ngModel)]="vendorInfo.primaryContactEmail">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorContactPhone" class="form-label">Phone</label>
                <input type="text" class="form-control form-control-lg" id="vendorContactPhone" placeholder="Phone" name="vendorContactPhone" [(ngModel)]="vendorInfo.primaryContactPhone">
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <hr />
        <div class="row gx-3">
            <div class="col-md mb-3 custom-file-input">
                <label for="vendorLogoPhoto" class="form-label d-block">Logo</label>
                <div class="hidden-file-input">
                    <input type="file" ng2FileSelect [uploader]="uploader" />
                    <button type="button" class="btn btn-white btn-lg"><i class="far fa-upload"></i> Choose File</button>
                </div>
            </div>
        </div>
        <div class="row gx-3" *ngIf="vendorInfo.logo">
            <div class="col-md mb-3">
                <div class="position-relative">
                    <button type="button" class="btn btn-white floating-action-button top right" rel="tooltip" data-bs-placement="top" title="Remove Photo" (click)="removeLogo()"><i class="far fa-times"></i></button>
                    <img [src]="vendorInfo.logo.fileUrl" alt="vendor logo" />
                </div>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Save</button>
    </div>
</form>